export const BOOKING_STATUSES = ["Pending", "Confirmed", "In Progress", "Completed", "Cancelled"];
export const PAYMENT_STATUSES = ["Pending", "Paid", "Failed"];

export const STATUS_STYLES = {
  Pending: "bg-amber-50 text-amber-700 border-amber-200",
  Confirmed: "bg-sky-50 text-sky-700 border-sky-200",
  "In Progress": "bg-violet-50 text-violet-700 border-violet-200",
  Completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Cancelled: "bg-rose-50 text-rose-700 border-rose-200",
};

export const PAYMENT_STYLES = {
  Pending: "bg-amber-50 text-amber-700 border-amber-200",
  Paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Failed: "bg-rose-50 text-rose-700 border-rose-200",
};

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");

export const Pill = ({ value, styles, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold border whitespace-nowrap ${styles[value] || "bg-slate-50 text-slate-600 border-slate-200"}`}>
    {value}
  </span>
);

export const fieldCls = "rounded-xl bg-white border border-warm px-3 py-2 text-sm focus:outline-none focus:border-terracotta focus:ring-1 focus:ring-terracotta";
